import { REACT_APP_API_URL } from '../../setup/config';
import axios, { handleApiError } from '../axios';

export const getCashFlowCompanyData = async (body) => {
    try {
        const response = await axios.post(`${REACT_APP_API_URL}/cashflow`);
        return response.data;
    } catch (error) {
        return handleApiError(error)
    }
}